<div class="representative-merchants-card" data-cy="representative-merchants-card">
  <div class="representative-merchants-card-header">
    <h2>Merchants</h2>

    <p-button
      *ngIf="mode === 'view'"
      (onClick)="edit()"
      icon="pi pi-file-edit"
      label="Edit"
      size="large"
      id="edit-representative-merchants-button"
      data-cy="edit-representative-merchants"
    ></p-button>
    <div *ngIf="mode === 'edit'" class="representative-merchants-card-header-edit-actions">
      <p-button
        (onClick)="cancel()"
        [disabled]="isSaving"
        icon="pi pi-ban"
        label="Cancel"
        size="large"
        id="cancel-representative-merchants-button"
        data-cy="cancel-representative-merchants"
      ></p-button>
      <p-button
        (onClick)="save()"
        [disabled]="isSaving"
        [loading]="isSaving"
        icon="pi pi-check-square"
        label="Save"
        size="large"
        id="save-representative-merchants-button"
        data-cy="save-representative-merchants"
      ></p-button>
    </div>
  </div>

  <div class="representative-merchants-card-body">
    <p-table [value]="merchants" [loading]="isLoading" data-cy="representative-merchants-table">
      <ng-template pTemplate="body" let-merchant>
        <tr>
          <td>
            <a
              *ngIf="mode === 'view'; else merchantNamePlain"
              (click)="merchantClicked.emit(merchant.MerchantId)"
              data-cy="representative-merchant-link"
              >{{ merchant.MerchantName }}</a
            >
            <ng-template #merchantNamePlain>{{ merchant.MerchantName }}</ng-template>
          </td>
          <td class="representative-merchants-remove-cell">
            <p-button
              [style.visibility]="mode === 'edit' ? 'visible' : 'hidden'"
              [disabled]="mode !== 'edit'"
              (onClick)="removeMerchant(merchant.MerchantId)"
              icon="pi pi-times"
              [rounded]="true"
              [text]="true"
              size="small"
              data-cy="remove-representative-merchant"
            ></p-button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="2" data-cy="representative-merchants-empty">No merchants assigned.</td>
        </tr>
      </ng-template>
    </p-table>

    <p-dropdown
      *ngIf="mode === 'edit'"
      [options]="addableMerchants"
      optionLabel="Name"
      optionValue="MerchantId"
      [(ngModel)]="merchantToAdd"
      (onChange)="addMerchant($event.value)"
      placeholder="Add a merchant"
      class="representative-merchants-add-dropdown"
      data-cy="add-representative-merchant"
    ></p-dropdown>

    <div *ngIf="mode === 'edit'" class="representative-merchants-card-footer-edit-actions">
      <p-button
        (onClick)="cancel()"
        [disabled]="isSaving"
        icon="pi pi-ban"
        label="Cancel"
        size="large"
        id="cancel-representative-merchants-button-footer"
        data-cy="cancel-representative-merchants-footer"
      ></p-button>
      <p-button
        (onClick)="save()"
        [disabled]="isSaving"
        [loading]="isSaving"
        icon="pi pi-check-square"
        label="Save"
        size="large"
        id="save-representative-merchants-button-footer"
        data-cy="save-representative-merchants-footer"
      ></p-button>
    </div>
  </div>
</div>
